"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Permissions = _interopRequireDefault(require("./Permissions"));

var _ApiRequest = _interopRequireDefault(require("../network/api/ApiRequest"));

var _MapRequest = _interopRequireDefault(require("../network/maps/MapRequest"));

var _globals = require("../globals");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account =
/** @class */
function () {
  function Account(id, secret) {
    this.id = id;
    this.secret = secret;
    this.servers = _globals.servers;
    this._permissions = new _Permissions.default(id, secret);
  }

  Account.prototype.credentials = function () {
    return {
      id: this.id,
      secret: this.secret
    };
  };

  Account.prototype.permissions = function () {
    return this._permissions;
  };

  Account.prototype.canAccess = function (endpoint) {
    return this.permissions().canAccess(endpoint);
  };
  /**
   * Creates and returns a new ApiRequest configured for the account.
   *
   * @returns {ApiRequest}
   * @memberof Account
   */


  Account.prototype.api = function (config) {
    return new _ApiRequest.default((0, _utils.extend)({
      server: this.servers.api,
      client: {
        id: this.id,
        secret: this.secret
      }
    }, config));
  };
  /**
   * Creates and returns a new MapRequest configured for the account.
   *
   * @returns {MapRequest}
   * @memberof Account
   */


  Account.prototype.map = function (config) {
    return new _MapRequest.default((0, _utils.extend)({
      server: this.servers.maps,
      client: {
        id: this.id,
        secret: this.secret
      }
    }, config));
  };

  return Account;
}();

var _default = Account;
exports.default = _default;
module.exports = exports.default;